import type { InstrumentRow, InstrumentType, RequirementRow } from '@api/replenishment-engine';

/** A row of a party's table: an instrument, or a dip the window cannot start (`blocked` set). */
export type PartyRow = InstrumentRow & { blocked?: RequirementRow };

export const blockedStub = (req: RequirementRow, type: InstrumentType): PartyRow => ({
    id: `blocked:${req.id}`,
    type,
    status: 'PROPOSED',
    productId: req.productId,
    sku: req.sku,
    requirementSeq: req.seq,
    itemKind: 'PRODUCT',
    itemId: req.madeAsProductId ?? req.productId,
    itemName: req.productName,
    unit: null,
    fromFacilityId: req.facilityId,
    toFacilityId: null,
    vendorId: null,
    vendorName: null,
    vendorCandidates: [],
    choicePending: false,
    leadDays: null,
    qty: 0,
    tranche: req.part,
    groupKey: '',
    placeBy: req.startDate ?? req.placeBy ?? '',
    needBy: req.landDate ?? '',
    landDate: req.landDate ?? '',
    dependsOnInstrumentIds: [],
    dependsOn: [],
    feeds: [],
    requirement: { dipDate: req.dipDate, zeroDate: req.zeroDate, stockoutDays: req.stockoutDays, landStatus: req.landStatus, startDate: req.startDate, landDate: req.landDate },
    pinned: null,
    claimedBy: null,
    reason: {},
    approvedAt: null,
    approvedQty: null,
    documentType: null,
    documentId: null,
    documentCode: null,
    expectedLandDate: null,
    receivedQty: 0,
    blocked: req,
});
